import { useState } from "react";
// import useBrowser from '../../hooks/useBrowser';
const PasswordField = ({
  label,
  autoComplete="current-password",
  type,
  id,
  need_icon,
  name,
  placeholder = "",
  iconPlacement,
  fieldValue,
  setFieldValue,
  setFieldValueOnBlur
}) => {
  const [showPassword, setShowPassword] = useState(false);
  // const browser = useBrowser();
  // const isWebkitBrowser = browser === "Chrome" || browser === "Safari" || browser === "Edge";
  // const inputType = isWebkitBrowser && !showPassword ? "text" : showPassword ? "text" : "password";
  // const inputStyle = isWebkitBrowser && !showPassword ? { WebkitTextSecurity: "disc" } : {};
  return (
    <>
      <label htmlFor={id} className="block text-base text-light-black mb-3">
        {label}
      </label>
      <div className="relative">
        {/* <input type="password" name="password" id="password" /> */}
        <input
        type={showPassword ? "text" : "password"}
          tabIndex="0"
          id={id}
          name={name}
          className={`py-3 px-4 ${iconPlacement === "left" ? "ps-11" : "pe-11"
            } h-12 block bg-transparent w-full border-dark-blue rounded-lg text-md focus:border-blue-500 focus:ring-blue-500`}
          placeholder={placeholder}
          value={fieldValue}
          onChange={setFieldValue}
          onBlur={setFieldValueOnBlur}
          // autoFocus=""
         {...(type === "password" && { autoComplete: autoComplete })}
        />
        {
          // id !== 'registerConfirmPassword' ?
          need_icon ?
            <button
              type="button"
              onClick={() => {
                setShowPassword(!showPassword);
              }}
              className="absolute inset-y-0 end-0 flex items-center z-20 px-3 cursor-pointer text-gray-400 rounded-e-md focus:outline-none focus:text-blue-600"
            >
              <svg
                className="shrink-0 size-3.5"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path
                  className={`${showPassword ? 'hidden hs-password-active:block' : 'hs-password-active:hidden'} `}
                  d="M9.88 9.88a3 3 0 1 0 4.24 4.24"
                ></path>
                <path
                  className={`${showPassword ? 'hidden hs-password-active:block' : 'hs-password-active:hidden'} `}
                  d="M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68"
                ></path>
                <path
                  className={`${showPassword ? 'hidden hs-password-active:block' : 'hs-password-active:hidden'} `}
                  d="M6.61 6.61A13.526 13.526 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61"
                ></path>
                <line
                  className={`${showPassword ? 'hidden hs-password-active:block' : 'hs-password-active:hidden'} `}
                  x1="2"
                  x2="22"
                  y1="2"
                  y2="22"
                ></line>
                <path
                  className={`${showPassword ? 'hs-password-active:hidden' : 'hidden hs-password-active:block'} `}
                  d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"
                ></path>
                <circle
                  className={`${showPassword ? 'hs-password-active:hidden' : 'hidden hs-password-active:block'} `}
                  cx="12"
                  cy="12"
                  r="3"
                ></circle>
              </svg>
            </button>
            : null
        }
      </div>
    </>
  );
};

export default PasswordField;
